/**
 * @generated SignedSource<<4e04f1a2ef6e7b4e856f9a23e20c1c9b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type HotelSource = "ETG" | "TEDO";
import { FragmentRefs } from "relay-runtime";
export type HotelListRow_hotel$data = {
  readonly id: string;
  readonly name: string;
  readonly source: HotelSource | null;
  readonly " $fragmentSpreads": FragmentRefs<"EntityTableRow_entity">;
  readonly " $fragmentType": "HotelListRow_hotel";
};
export type HotelListRow_hotel$key = {
  readonly " $data"?: HotelListRow_hotel$data;
  readonly " $fragmentSpreads": FragmentRefs<"HotelListRow_hotel">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HotelListRow_hotel",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "source",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntityTableRow_entity"
    }
  ],
  "type": "Hotel",
  "abstractKey": null
};

(node as any).hash = "61306d13f499c8abeaaa3d37ea0b3355";

export default node;
